export const START_ORDER_GAME_COMPLETED = "orderDriver/startCompleted";
export const SUBMIT_ORDER_COMPLETED = "orderDriver/submitCompleted";
export const GET_ORDER_GAME_COMPLETED = "orderDriver/getGameCompleted";